export default {
  populations: [],
  payScaleIntervals: {},
  systemVariables: [],
  eligibilityOperators: [],
  lookupValues: {},
  savingPopulation: false,
  saveError: null,
};
